<template>
  <div>
    <div v-if="this.$store.state.customModule.total" class="div-subject">
      <img class="img-left" src="http://hpc.devotedigital.cn/resources/img/background.png">
      <img class="img-right" :src="rigntImg">
      <!-- 两个线条 -->
      <div class="line">
        <img class="lineUpper" src="http://hpc.devotedigital.cn/resources/img/lineUpper.png">
        <div class="divText">{{ divText }}</div>
        <img class="lineLower" src="http://hpc.devotedigital.cn/resources/img/lineLower.png">
      </div>
      <!-- 关闭按钮 -->
      <img class="img-close" src="http://hpc.devotedigital.cn/resources/img/close.png" @click="totalShowClick">
      <!-- 循环五个div -->
      <div class="location">
        <div
          v-for="(item,index) in btn"
          :key="index"
          ref="div"
          :class="index===leftIndex ? `btn${index} left-menu-active` : `btn${index} left-menu`"
          @click="clickDivLeft(item.action,index)"
        >
          <span class="menu-text">
            {{
              item.action.z_name
            }}
          </span>
        </div>
      </div>
      <!-- 循环四个个div -->
      <!-- <div v-if="this.$store.state.customModule.fourDivShow">
        <div
          v-for="item in divData"
          :key="item.name"
          class="btn-four-div"
          :style="getStyle(item)"
          @click="clickDivRight(item.action)"
        />
      </div>-->
      <!-- 实验 -->
      <div v-if="this.$store.state.customModule.fourDivShow" class="belowImg">
        <div
          v-for="(item,index) in divData"
          :key="item.name"
          :class="item.number==='one'?'btn-four-div setwidth':item.number==='two'?'btn-four-div setwidth':item.number==='three'?index===0?'btn-four-div':'btn-four-div setwidth':item.number==='four'?'btn-four-div':item.number==='third'?'btn-four-div setwidththird':''"
          :style="getStyle(item)"
          @click="clickDivRight(item.action)"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      btn: [],
      leftImg: 'http://hpc.devotedigital.cn/resources/img/select_pop/jisuan_left.png',
      rigntImg: 'http://hpc.devotedigital.cn/resources/img/total.png',
      // 存放div的数据
      divData: [],
      // 保存点击左侧div后的index
      leftIndex: 0,
      divText:
        '计算，是人类永恒的需求，也是智能世界的源动力。华为计算， 围绕“鲲鹏计算平台”， “昇腾计算平台”和 “x86计算平台”，在通用计算和AI计算领域坚持战略投入，以创新为世界提供最强算力。'
    }
  },
  mounted() {
    const json = require('@media/dataBtn.json')
    this.btn = json.btns
    const getJsonDiv = require('@media/rotationDiv.json')
    this.jsonDiv = getJsonDiv
    this.divData = this.jsonDiv.rotationDivFirst
  },
  updated() {},
  methods: {
    totalShowClick() {
      this.$store.commit('customModule/setTotal', false)
      this.$store.commit('customModule/setFourDivShow', false)
      this.$emit('divClose')
    },
    getStyle(data) {
      return {
        left: (data.left / 1920) * 100 + '%',
        top: (data.top / 1080) * 100 + '%',
        // width: (data.width / 1080) * 100 + '%',
        // height: (data.height / 1080) * 100 + '%',
        // backgroundColor: data.backgroundColor,
        backgroundImage: data.backgroundImage
      }
    },
    clickDivLeft(action, index) {
      switch (action.type) {
        case 'left':
          this.leftImg = action.left_img
          this.rigntImg = action.right_img
          this.divText = action.text
          if (action.num === 'rotationDivFirst') {
            this.divData = this.jsonDiv.rotationDivFirst
          } else if (action.num === 'rotationDivSecond') {
            this.divData = this.jsonDiv.rotationDivSecond
          } else if (action.num === 'rotationDivThird') {
            this.divData = this.jsonDiv.rotationDivThird
          } else if (action.num === 'rotationDivFourth') {
            this.divData = this.jsonDiv.rotationDivFourth
          } else if (action.num === 'rotationDivFifth') {
            this.divData = this.jsonDiv.rotationDivFifth
          }

          for (var i = 0; i <= 4; i++) {
            if (i === index) {
              this.$refs.div[i].className = `btn${i} left-menu-active`
            } else {
              this.$refs.div[i].className = `btn${i} left-menu`
            }
          }
          // 保存index
          this.leftIndex = index
      }
    },
    clickDivRight(action) {
      this.$store.commit('customModule/setTotal', false)
      this.$store.commit('customModule/setoverall', true)
      this.$store.commit('customModule/setOverallDivText', action.text)
      this.$emit('chanageImg', 'http://hpc.devotedigital.cn/resources/img/industry.png')
      // 判断需要轮播的是图片还是视频
      switch (action.rotationType) {
        case 'img':
          this.$store.commit(
            'customModule/setOveralloverallImg',
            action.img[0]
          )
          this.$store.commit('customModule/setoverallImgArray', action.img)
          this.$store.commit('customModule/setIsImgOrVideo', 'img')
          if (action.name === 'onlyOneData') {
            this.$store.commit('customModule/setBtnImgShow', 'allHide')
          } else {
            this.$store.commit('customModule/setBtnImgShow', 'leftHide')
          }
          break
        case 'video':
          this.$store.commit(
            'customModule/setOveralloverallImg',
            action.video[0]
          )
          this.$store.commit('customModule/setoverallImgArray', action.video)
          this.$store.commit('customModule/setIsImgOrVideo', 'video')
          if (action.name === 'onlyOneData') {
            this.$store.commit('customModule/setBtnImgShow', 'allHide')
          } else {
            this.$store.commit('customModule/setBtnImgShow', 'leftHide')
          }
          break
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.location {
  position: absolute;
  top: 80px;
  left: -100px;
  width: 25%;
  height: 80%;
  // background-color: whitesmoke;
  div {
    cursor: pointer;
    position: absolute;
    width: 305px;
    height: 60px;
    left: 5vw;
    top: 100px;
    .menu-text {
      padding-left: 46px;
      padding-top: 2px;
      font-size: 26px;
      position: absolute;
      left: 15px;
      top: 10px;
    }
  }
  .btn0 {
    top: 100px;
  }
  .btn1 {
    top: 200px;
  }
  .btn2 {
    top: 300px;
  }
  .btn3 {
    top: 400px;
  }
  .btn4 {
    top: 500px;
  }
  .left-menu {
    background-image: url("http://hpc.devotedigital.cn/resources/img/unclick.png");
    background-size: 100% 100%;
    color: #01baf3;
  }
  .left-menu-active {
    background-image: url("http://hpc.devotedigital.cn/resources/img/click.png");
    background-size: 100% 100%;
    color: #00ffff;
  }
}
.divText {
  width: 100%;
  text-align: center;
  word-break: break-all;
  font-size: 20px;
  color: rgb(255, 255, 255);
  line-height: 35px;
}
.line {
  position: absolute;
  width: 60%;
  height: 42%;
  left: 30%;
  top: 5%;
  // background: wheat;
}
.lineUpper {
  margin-top: 30px;
  margin-bottom: 10px;
  width: 100%;
}
.lineLower {
  margin-top: 10px;
  width: 100%;
}
.btn-div {
  position: absolute;
  cursor: pointer;
}
.btn-four-div {
  cursor: pointer;
  position: absolute;
  background-size: 100% 100%;
  // background-color: brown;
}
.div-subject {
  position: absolute;
  width: 70vw;
  height: 70vh;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  .img-left {
    position: absolute;
    top: 20px;
    left: -130px;
    width: 45%;
  }
  .img-right {
    position: absolute;
    top: 10px;
    left: 360px;
    width: 80%;
  }
  .img-close {
    cursor: pointer;
    position: absolute;
    top: 50px;
    right: -60px;
    width: 60px;
    height: 60px;
  }
}
.belowImg {
  position: absolute;
  left: 550px;
  top: 280px;
  width: 60%;
  height: 50%;
  // background-color: white;
  .btn-four-div {
    cursor: pointer;
    position: absolute;
    background-size: 100% 100%;
    width: 200px;
    height: 240px;
    // background-image: url('/img/buttonImg/intelligence1.png');
  }
  .setwidth {
    width: 240px;
  }
  .setwidththird {
    width: 300px;
  }
}
</style>
